/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface LockUpsRequest
 */
export interface LockUpsRequest {
    /**
     * 
     * @type {number}
     * @memberof LockUpsRequest
     */
    manageSerial: number;
}

export function LockUpsRequestFromJSON(json: any): LockUpsRequest {
    return LockUpsRequestFromJSONTyped(json, false);
}

export function LockUpsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LockUpsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'manageSerial': json['manageSerial'],
    };
}

export function LockUpsRequestToJSON(value?: LockUpsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'manageSerial': value.manageSerial,
    };
}


